module.exports = __webpack_public_path__ + "img/Multi-account-7.358f7301.png";